(() => {
  const initPhotoModal = (section) => {
    const modal = section.querySelector('[data-review-modal]');
    const triggers = section.querySelectorAll('[data-review-image]');
    if (!modal || !triggers.length) return;

    const panel = modal.querySelector('[data-review-modal-panel]');
    const fields = {
      image: modal.querySelector('[data-review-modal-image]'),
      stars: modal.querySelector('[data-review-modal-stars]'),
      title: modal.querySelector('[data-review-modal-title]'),
      body: modal.querySelector('[data-review-modal-body]'),
      author: modal.querySelector('[data-review-modal-author]'),
      date: modal.querySelector('[data-review-modal-date]'),
      verified: modal.querySelector('[data-review-modal-verified]'),
    };

    const setOptional = (el, html) => {
      if (!el) return;
      if (html && html.trim()) {
        el.innerHTML = html;
        el.classList.remove('hidden');
      } else {
        el.innerHTML = '';
        el.classList.add('hidden');
      }
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const article = trigger.closest('[data-review-item]');
        const src = trigger.dataset.imageSrc;
        if (fields.image && src) {
          fields.image.src = src;
          fields.image.alt = article?.querySelector('[data-rv-author]')?.textContent || '';
        }
        if (fields.stars) fields.stars.innerHTML = article?.querySelector('[data-rv-stars]')?.innerHTML || '';
        setOptional(fields.title, article?.querySelector('[data-rv-title]')?.innerHTML);
        setOptional(fields.body, article?.querySelector('[data-rv-body]')?.innerHTML);
        setOptional(fields.verified, article?.querySelector('[data-rv-verified]')?.innerHTML);
        if (fields.author) fields.author.textContent = article?.querySelector('[data-rv-author]')?.textContent || '';
        if (fields.date) fields.date.textContent = article?.querySelector('[data-rv-date]')?.textContent || '';
        modal.showModal();
      });
    });

    modal.querySelector('[data-review-modal-close]')?.addEventListener('click', () => modal.close());
    modal.addEventListener('click', (event) => {
      if (panel && !panel.contains(event.target)) modal.close();
    });
  };

  const initTranslationToggles = (section) => {
    section.querySelectorAll('[data-review-translated]').forEach((bodyEl) => {
      const article = bodyEl.closest('[data-review-item]');
      const btn = article?.querySelector('[data-review-show-original]');
      const titleEl = article?.querySelector('[data-rv-title]');
      if (!btn) return;

      const translatedBody = bodyEl.dataset.translatedBody || '';
      const originalBody = bodyEl.dataset.originalBody || '';
      const translatedTitle = titleEl?.dataset.translatedTitle || '';
      const originalTitle = titleEl?.dataset.originalTitle || '';
      let showingOriginal = false;

      btn.addEventListener('click', () => {
        showingOriginal = !showingOriginal;
        bodyEl.innerHTML = (showingOriginal ? originalBody : translatedBody).replace(/\n/g, '<br>');
        if (titleEl && (translatedTitle || originalTitle)) {
          titleEl.textContent = showingOriginal ? originalTitle : translatedTitle;
        }
        btn.textContent = showingOriginal
          ? btn.dataset.showTranslated || 'Show translation'
          : btn.dataset.showOriginal || 'Show original';
      });

      btn.dataset.showOriginal = btn.textContent.trim();
      btn.dataset.showTranslated = btn.dataset.showTranslated
        || section.dataset.showTranslatedLabel
        || 'Show translation';
    });
  };

  const refreshDividers = (items) => {
    const visible = items.filter((el) => !el.classList.contains('hidden'));
    items.forEach((el) => el.classList.remove('border-b', 'border-gray-200'));
    visible.forEach((el, index) => {
      if (index < visible.length - 1) {
        el.classList.add('border-b', 'border-gray-200');
      }
    });
  };

  const init = (section) => {
    initPhotoModal(section);
    initTranslationToggles(section);

    const perPage = parseInt(section.dataset.perPage, 10) || 5;
    const items = Array.from(section.querySelectorAll('[data-review-item]'));
    const pagination = section.querySelector('[data-reviews-pagination]');

    refreshDividers(items);

    if (items.length <= perPage || !pagination) return;

    const prev = pagination.querySelector('[data-reviews-prev]');
    const next = pagination.querySelector('[data-reviews-next]');
    const status = pagination.querySelector('[data-reviews-status]');
    const template = status?.dataset.template || 'Page __CURRENT__ of __TOTAL__';
    const totalPages = Math.ceil(items.length / perPage);
    let page = 1;

    const render = () => {
      const start = (page - 1) * perPage;
      const end = start + perPage;
      items.forEach((el, index) => el.classList.toggle('hidden', index < start || index >= end));
      refreshDividers(items);
      if (prev) prev.disabled = page <= 1;
      if (next) next.disabled = page >= totalPages;
      if (status) {
        status.textContent = template
          .replace('__CURRENT__', String(page))
          .replace('__TOTAL__', String(totalPages));
      }
    };

    prev?.addEventListener('click', () => {
      if (page > 1) {
        page -= 1;
        render();
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    next?.addEventListener('click', () => {
      if (page < totalPages) {
        page += 1;
        render();
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    render();
  };

  document.querySelectorAll('[data-reviews-section]').forEach(init);
})();
